import * as React from 'react';
import { Swiper, SwiperSlide, useSwiper } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import SwiperCore, { Autoplay, Pagination, Navigation } from 'swiper';
import BenefitsCarouselTabs from '../BenefitsCarouselTabs/BenefitsCarouselTabs';

import arrowRight from '../../images/right-circled-arrow.svg';
import arrowLeft from '../../images/left-circled-arrow.svg';

import medical from '../../images/medical-icon.svg';
import dental from '../../images/dental-icon.svg';
import vision from '../../images/vision-icon.svg';
import life from '../../images/life-icon.svg';
import employee from '../../images/employee-icon.svg';
import pto from '../../images/pto-icon.svg';
import retirement from '../../images/retirement-icon.svg';
import otherBenefits from '../../images/other-benefits-icon.svg';
import discounts from '../../images/discounts-icon.svg';
import future from '../../images/future-icon.svg';

import image0 from '../../images/BT_Benefits_Carousel_00.png';
import image1 from '../../images/BT_Benefits_Carousel_01.jpg';
import image2 from '../../images/BT_Benefits_Carousel_02.png';
import image3 from '../../images/BT_Benefits_Carousel_03.png';
import image4 from '../../images/BT_Benefits_Carousel_04.jpg';
import image5 from '../../images/BT_Benefits_Carousel_05.jpg';
import image6 from '../../images/BT_Benefits_Carousel_06.jpg';
import image7 from '../../images/BT_Benefits_Carousel_07.jpg';
import image8 from '../../images/BT_Benefits_Carousel_08.jpg';
import image9 from '../../images/BT_Benefits_Carousel_09.jpg';

interface BenefitsCarouselItems {}

const BenefitsCarousel: React.FC<BenefitsCarouselItems> = (
	props: BenefitsCarouselItems
) => {
	const [activeIdx, setActiveIdx] = React.useState(0);

	SwiperCore.use([Autoplay, Pagination, Navigation]);

	const benefits = [
		{
			icon: medical,
			image: image0,
			imageClass: 'object-[70%_0]',
			title: 'Medical',
			perks: [
				{
					name: 'Blue Cross Blue Shield',
					description: ''
				},
				{
					name: 'Choose from various PPO Plans to best suit your family’s needs'
				},
				{
					name: '24/7 Virtual Doctor Visits',
					description: ''
				},
				{
					name: 'Free Teledoc Visits for Common Illnesses',
					description: ''
				},
				{
					name: 'Rx Drug Discount',
					description: ''
				}
			]
		},
		{
			icon: dental,
			image: image1,
			title: 'Dental',
			perks: [
				{
					name: 'Blue Cross Blue Shield',
					description: ''
				},
				{
					name: 'Standard and Premium dental plans',
					description: ''
				},
				{
					name: 'Orthodontia services for dependents through age 18',
					description: ''
				}
			]
		},
		{
			icon: vision,
			image: image2,
			imageClass: 'object-top !opacity-90',
			title: 'Vision',
			perks: [
				{
					name: 'National Vision Administrators (NVA',
					description: ''
				},
				{
					name: 'Standard and Premium Vision Plans',
					description: ''
				},
				{
					name: 'All vision plans allow employees to receive contact lenses AND frames every year!',
					description: ''
				},
				{
					name: 'Employees enrolled in our vision coverage also have the option to elect Prescription Safety Glasses coverage that covers frames and lenses once a year.',
					description: ''
				}
			]
		},
		{
			icon: life,
			image: image3,
			title: 'Life & Disability Insurance',
			imageClass: '!opacity-100',
			perks: [
				{
					name: 'Guardian',
					description: ''
				},
				{
					name: 'Company Paid Short Term and Long-Term Disability Plans',
					description: ''
				},
				{
					name: 'Company-Paid Basic Life Insurance (All Full-Time Regular Employees)',
					description: ''
				},
				{
					name: 'Supplemental Life Insurance (employees and dependents)',
					description: ''
				},
				{
					name: 'Supplemental Short- & Long-Term Disability Insurance',
					description: ''
				}
			]
		},
		{
			icon: otherBenefits,
			image: image7,
			imageClass: 'object-top',
			title: 'Other Benefits',
			perks: [
				{
					name: 'Health Care and Dependent Care Flexible Spending Accounts (FSAs)',
					description: ''
				},
				{
					name: 'Commuter Benefits',
					description: ''
				},
				{
					name: 'Accident Insurance',
					description: ''
				},
				{
					name: 'Critical Illness Insurance',
					description: ''
				},
				{
					name: 'Legal and Identity Theft Protection',
					description: ''
				},
				{
					name: 'Mortgage Rate Discount Program',
					description: ''
				}
			]
		},
		{
			icon: employee,
			image: image4,
			title: 'Employee Assistance Programs',
			perks: [
				{
					name: 'Employees have access to free in-person or telehealth counseling to support you through life’s challenges, from bereavement support to work-life resources like child and elder care referrals and employee discounts.',
					description: ''
				},
				{
					name: 'Expert legal and financial guidance for wills, taxes, identity protection and more is available to help you thrive personally and professionally.',
					description: ''
				}
			]
		},
		{
			icon: retirement,
			image: image6,
			title: 'Retirement',
			perks: [
				{
					name: '401(k) with Discretionary Company Match',
					description: ''
				},
				{
					name: 'Roth and Traditional Contribution Options',
					description: ''
				},
				{
					name: 'Auto Enrolled for New Hires',
					description: ''
				},
				{
					name: 'Free Financial Resources',
					description: ''
				}
			]
		},
		{
			icon: pto,
			image: image5,
			title: 'Paid Time Off',
			perks: [
				{
					name: 'Paid Time Off and Sick Time',
					description: ''
				},
				{
					name: 'Paid Parental Leave',
					description: ''
				},
				{
					name: 'Paid Volunteer Time',
					description: ''
				},
				{
					name: 'Additional Paid Leaves Available ',
					description: ''
				}
			]
		},
		{
			icon: future,
			image: image9,
			imageClass: 'object-top',
			title: 'Investing in Your Future',
			perks: [
				{
					name: 'Recognition Awards and Contest Trips',
					description: ''
				},
				{
					name: 'ASE Certification Reimbursement',
					description: ''
				},
				{
					name: 'Belle Tire Auto Technician Development Program',
					description: ''
				},
				{
					name: 'Belle Tire Automotive Scholarship Program',
					description: ''
				}
			]
		},

		{
			icon: discounts,
			image: image8,
			title: 'Employee Discounts',
			perks: [
				{
					name: 'Discounts on Tires, Repairs, and More',
					description: ''
				},
				{
					name: 'Employee Discount Platform that includes discounts on cruises, hotels, movie tickets, amusement parks, and more',
					description: ''
				},
				{
					name: 'Discounts on Professional Sporting Events including baseball, hockey, basketball',
					description: ''
				},
				{
					name: 'Everyday Discounts such as Dell, Verizon and Enterprise',
					description: ''
				}
			]
		}
	];

	return (
		<section className={''}>
			<Swiper
				modules={[Navigation, Pagination, Autoplay]}
				loop
				autoplay={{ delay: 7000, pauseOnMouseEnter: true }}
				slidesPerView={1}
				navigation={{
					nextEl: '.custom-swiper-next',
					prevEl: '.custom-swiper-prev'
				}}
				pagination={{
					el: '.custom-swiper-pagination',
					clickable: true
				}}
				className="relative"
				onActiveIndexChange={(swiper) => {
					console.log(swiper.activeIndex);
					setActiveIdx(swiper.activeIndex);
				}}
			>
				<BenefitsCarouselTabs
					slides={benefits}
					activeIndex={
						activeIdx <= benefits.length
							? activeIdx < 1
								? benefits.length
								: activeIdx
							: 1
					}
				/>
				<button className="custom-swiper-prev absolute top-1/2 left-56 z-10 max-xl:left-24 max-lg:hidden">
					<img src={arrowLeft} alt="" className="" />
				</button>
				<button className="custom-swiper-next absolute top-1/2 right-56 z-10 max-xl:right-24 max-lg:hidden">
					<img src={arrowRight} alt="" className="" />
				</button>
				{benefits.map((benefit, index) => (
					<SwiperSlide
						key={index}
						className="!h-auto bg-black opacity-100"
					>
						<img
							src={benefit.image}
							alt=""
							className={`absolute z-0 h-full w-full object-cover opacity-50 ${
								benefit.imageClass ? benefit.imageClass : ''
							}`}
						/>
						<div className="relative z-10 mx-auto flex max-w-3xl flex-col items-center justify-center px-4 pt-[350px] pb-36 text-white max-lg:pt-64">
							<p className="mb-6 text-center !font-rubik text-5xl font-semibold max-lg:text-4xl">
								{benefit.title}
							</p>
							<ul className="list-inside !list-disc gap-4 ">
								{benefit.perks?.map((perk, i) => (
									<li
										key={i}
										className="mb-2 items-start justify-center gap-2 text-center text-2xl"
									>
										{perk.name}
										{perk.description && (
											<p className="italic">
												{perk.description}
											</p>
										)}
									</li>
								))}
							</ul>
						</div>
					</SwiperSlide>
				))}
				<div className="absolute bottom-4 left-1/2 z-10 flex w-max -translate-x-1/2 items-center justify-center gap-4 lg:hidden">
					<div className="custom-swiper-pagination !w-fit"></div>
				</div>
			</Swiper>
		</section>
	);
};

export default BenefitsCarousel;
